// extracted by mini-css-extract-plugin
export default {"container":"Link_container__B7JqC","sendButton":"Link_sendButton__sYE4g"};